<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <!-- <img :src="importedImg1" alt="" class="imgItem1" /> -->
        <p class="imgItem1">ติดต่อเรา</p>
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <!-- <img :src="importedImg2" alt="" class="imgItem2" /> -->
        <div class="msg1">
          <p>MACKALE GROUP PUBLIC COMPANY LIMITED</p>
          <p><span>จดหมาย:</span>office@mackale.com</p>
          <p>
            <span>ที่อยู่:</span>45/360 Moo 6 Lam Luk Ka Road 12130 LUM LUK KA
          </p>
        </div>
        <!-- <ul class="msg2">
          <li>
            <span>อีเมล</span
            ><input
              placeholder="กรุณาเข้า"
              type="email"
              id="email"
              v-model="email"
              required
            />
          </li>
          <li>
            <span>ชื่อ</span
            ><input
              placeholder="กรุณาเข้า"
              type="text"
              id="name"
              v-model="name"
              required
            />
          </li>
          <li>
            <span>ข้อมูล</span
            ><textarea
              placeholder="กรุณาเข้า"
              id="message"
              v-model="message"
              required
            ></textarea>
          </li>
          <li @click="open">
            <a :href="mailtoLink" @click="showToast">ส่ง</a>
          </li>
        </ul> -->

        <ul class="msg2">
          <li>
            <span>อีเมล</span>
            <a-input
              class="inputBox"
              v-model="formValues.email"
              placeholder="กรุณาเข้า"
            >
              <template #suffix>
                <img :src="mailIcon" />
              </template>
            </a-input>
          </li>
          <li>
            <span>ชื่อ</span>
            <a-input
              class="inputBox"
              v-model="formValues.mailName"
              placeholder="กรุณาเข้า"
            >
              <template #suffix>
                <img :src="mailIcon" />
              </template>
            </a-input>
          </li>
          <li>
            <span>ข้อมูล</span>
            <a-textarea
              class="textareaBox"
              v-model="formValues.remark"
              placeholder="กรุณาเข้า"
              :auto-size="{ minRows: 10, maxRows: 10 }"
            />
          </li>
          <li>
            <div>
              <a-button
                type="primary"
                :disabled="
                  formValues.mailName === '' || formValues.remark === ''
                "
                :class="{
                  submitButton: true,
                  btnBgcolor:
                    formValues.mailName !== '' && formValues.remark !== '',
                }"
                @click="submitFn"
                :loading="isLoading"
                >ส่ง</a-button
              >
            </div>
          </li>
        </ul>
        <!-- <div class="form">
          <div class="inp">
            <a-input
              class="inputBox"
              v-model="formValues.email"
              placeholder="กรุณาเข้า"
            >
              <template #suffix>
                <img :src="mailIcon" />
              </template>
            </a-input>
            <a-input
              class="inputBox"
              v-model="formValues.mailName"
              placeholder="กรุณาเข้า"
            >
              <template #suffix>
                <img :src="mailIcon" />
              </template>
            </a-input>
          </div>

          <a-textarea
            class="textareaBox"
            v-model="formValues.remark"
            placeholder="กรุณาเข้า"
            :auto-size="{ minRows: 23, maxRows: 23 }"
          />
          <div>
            <a-button
              type="primary"
              :disabled="formValues.mailName === '' || formValues.remark === ''"
              :class="{
                submitButton: true,
                btnBgcolor:
                  formValues.mailName !== '' && formValues.remark !== '',
              }"
              @click="submitFn"
              :loading="isLoading"
              >ส่ง</a-button
            >
          </div>
        </div> -->
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <!-- <img :src="importedImg3" alt="" class="imgItem3" /> -->
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <!-- <img :src="importedImg4" alt="" class="imgItem4" /> -->
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <!-- <img :src="importedImg5" alt="" class="imgItem5" /> -->
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
      </div>
    </div>
    <!-- <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div> -->
  </div>
</template>

<script>
import "./index.css";
import { message } from "ant-design-vue";
// import importedImg1 from "@/page/geniefintechcompany/components/img/2_1.png";
// import importedImg2 from "@/page/geniefintechcompany/components/img/2_2.png";
// import importedImg3 from "@/page/geniefintechcompany/components/img/2_3.png";
// import importedImg4 from "@/page/geniefintechcompany/components/img/2_4.png";
// import importedImg5 from "@/page/geniefintechcompany/components/img/2_5.png";
// import importedImg6 from "@/page/geniefintechcompany/components/img/2_6.png";
// import importedImg7 from "@/page/geniefintechcompany/components/img/2_7.png";

export default {
  data() {
    return {
      // importedImg1: importedImg1,
      // importedImg2: importedImg2,
      // importedImg3: importedImg3,
      // importedImg4: importedImg4,
      // importedImg5: importedImg5,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      altText: "图片",

      formValues: {
        mailName: "",
        email: "",
        remark: "",
      },
      isLoading: false,
      // mailtoLink: "",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    submitFn() {
      if (this.formValues.mailName === "" || this.formValues.remark === "") {
        message.info("必填项不能为空");
        return;
      }
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        message.success("ส่งอีเมลเรียบร้อยแล้ว เราจะตอบกลับทันที");
        this.formValues = {
          mailName: "",
          email: "",
          remark: "",
        };
      }, 2000);
    },
  },
  computed: {
    // 生成mailto链接
    // mailtoLink() {
    //   const fixedEmail = "office@mackale.com"; // 固定邮箱地址
    //   return `mailto:${fixedEmail}?subject=Message from ${this.name}&body=${this.message} (From: ${this.email})`;
    // },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
  padding: 100px;
}

.img2Box {
  display: flex;
  justify-content: space-between;
  padding: 0 150px;
}

/* .msg1 {
  border: 1px solid red;
} */
.msg1 p {
  color: #666666;
  /* text-align: center; */
  font-family: "Thonburi";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
}
.msg1 p:first-child {
  color: #8a5d3c;
  font-size: 22px;
  font-weight: 700;
}
.msg1 p span {
  color: #999999;
  font-size: 20px;
  font-weight: 400;
}

.msg2 {
  /* border: 1px solid red; */
  display: flex;
  flex-wrap: wrap;
  width: 502px;
  gap: 20px;
}
.msg2 li {
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  width: 240px;
}

.msg2 li:nth-child(3) {
  width: 500px;
}

.msg2 li span {
  color: #444444;
  font-family: "Thonburi";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  opacity: 0.6;
  padding-bottom: 10px;
}
.msg2 li input,
textarea {
  all: unset; /* 移除所有默认样式 */
  border: none; /* 去除边框 */
  outline: none; /* 去除聚焦时的轮廓 */
  background: none; /* 去除背景 */
  color: inherit; /* 继承父元素的文本颜色 */
  font: inherit; /* 继承父元素的字体 */
  /* border: 1px solid red; */
  height: 30px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #f8f6f4;
  padding: 10px;
}

.msg2 li textarea {
  height: 200px;
}

.msg2 li a {
  width: 200px;
  height: 50px;
  line-height: 50px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #8a5d3c;
  color: #ffffff;
  text-align: center;
  font-family: "Thonburi";
  font-size: 20px;
  font-weight: 700;
}
.img2Box {
  margin-bottom: 200px;
}

.form {
  display: flex;
  flex-direction: column;
}

.inputBox {
  /* font-size: 18px;
  border: 2px solid #cdcdcd;
  border-radius: 10px;
  height: 50px; */
}

.inputBox >>> .ant-input {
  font-size: 18px;
  border: 2px solid #cdcdcd;
  border-radius: 10px;
  height: 56px;
}

/* .inputBox>>>.ant-input:focus {
  border: none;
  border-bottom: 1px solid white !important;
  box-shadow: 0 0 1px 2px #4263FF;
}

.inputBox>>>.ant-input:hover  {
  border: none;
  border-bottom: 1px solid white !important;
  box-shadow: 0 0 1px 2px #4263FF;
} */

.textareaBox {
  margin-top: 20px;
  border: 2px solid #cdcdcd;
  border-radius: 10px;
  font-size: 18px;
}
.textareaBox .ant-input {
  height: 200px;
}

.submitButton {
  /* background-color: #4263ff !important; */
  border: none;
  height: 40px;
  border-radius: 5px;
  margin-top: 20px;
  width: 120px;
  font-size: 18px;
}

.btnBgcolor {
  background-color: #8a5d3c !important;
}

.submitButton:hover {
  background-color: #8a5d3c;
}

.imgItem2 {
  width: 80%;
  margin-top: 20px;
}

.inp {
  display: flex;
}
</style>
